import React, { useState, useEffect } from 'react';
import Typography from "@mui/material/Typography";

function TextResizer(props) {
  const [fontSize, setFontSize] = useState(16); // Initial font size

  useEffect(() => {
    const words = props.text.split(' ');
    let shouldResizeSmall = false;
    let shouldResizeMedium = false;

    for (const word of words) {
        if (word.length > 12) {
            shouldResizeSmall = true;
        }
        else if (word.length > 9) {
            shouldResizeMedium = true;
        }
        break;
    }

    if (shouldResizeMedium) {
      setFontSize(18); // Decrease font size if any word is too long
    } else if (shouldResizeSmall){
        setFontSize(15)
    } 
    else {
      setFontSize(24); // Reset to the default font size
    }
  }, [props.text]);

  const styles = {
    text: {
      fontSize: `${fontSize}px`,
    },
  };

  return (
    <Typography variant="h5" component="div" className="text-resize" style={styles.text}>
      {props.text}
    </Typography>
  );
}

export default TextResizer;
